import React, {useEffect, useState} from "react"
import './App.css'
import UseAppData from "./data/app"
import UseYokohamaData from "./data/yokohama"
import MainView from "./core/views/main"
import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import {Box, Button, CircularProgress, Dialog, DialogActions, DialogTitle, Typography} from "@mui/material";
import DialogContext from "@mui/material/Dialog/DialogContext";
import IndexView from "./core/views";
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("Asia/Tokyo")

export const AppDataContext = React.createContext()
export const YokohamaDataContext = React.createContext()

const styles = {
    busyRoot: {
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    busyBox: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },
}

const App = () => {

    const useAppData = UseAppData()
    const useYokohamaData = UseYokohamaData()

    const [app, setApp] = useState()

    useEffect(() => {
        console.log(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN)

        const firebaseConfig = {
            apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
            measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
        }
        console.log(firebaseConfig)
        setApp(initializeApp(firebaseConfig))
    }, [])


    return (
        <AppDataContext.Provider value={useAppData}>
            <YokohamaDataContext.Provider value={useYokohamaData}>
                {app ? <IndexView app={app}/> : (
                    <Box style={styles.busyRoot}>
                        <Box style={styles.busyBox}>
                            <CircularProgress />
                            <Typography>読込中...</Typography>
                        </Box>
                    </Box>
                )}
            </YokohamaDataContext.Provider>
        </AppDataContext.Provider>
    )

}

export default App
